<style lang="scss" scoped>
.slide-11 {
  background-image: url("../../../assets/module3/slide11/background-02.jpg");
  background-size: cover;
  background-position: center;
  height: calc(100% - 0px);

  .polaroid {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .pages {
    z-index: 1;
    position: relative;
    padding-top: 130px;
    padding-right: 170px;
    justify-content: space-between;
  }

  .page {
    max-width: 535px;
    &--narrow {
      max-width: 435px;
    }
  }
  .page-left {
    flex-basis: 65%;
  }
  .page-right {
    flex-basis: 35%;
  }

  .heading1 {
    transform: rotate(-3deg);
    color: #94bbd2;
    font-size: 100px;
    padding-top: 70px;
    padding-left: 60px;
    margin-bottom: -80px;
  }
  .heading3 {
    color: #c5d43b;
    font-size: 43px;
    margin-left: 0;
    margin-bottom: 40px;
    max-width: 350px;
  }
  .challenge {
    color: #fff;
    font-size: 1.5em;
  }
  .heading2 {
    color: #c5d43b;
    margin-top: 70px;
    font-size: 48px;
  }

  .share {
    width: 160px;
    margin: 50px auto;
    cursor: pointer;
    transition: all 0.2s ease-out;
    &:hover {
      transform: scale(1.1);
    }
  }

  .copy--narrow {
    max-width: 340px;
  }
  .copy--bottom {
    position: absolute;
    bottom: 80px;
    max-width: 360px;
  }
}
</style>

<template>
  <div class="slide-11">
    <transition name="scale" appear>
      <div v-show="slideIndex == 10" class="heading">
        <h1 class="heading1">{{ $t("module3.slide11.heading1") }}</h1>
      </div>
    </transition>
    <div class="pages">
      <div class="page">
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 10" class="copy-left delay-1">
            <p class="copy" v-html="$t('module3.slide11.copy1')"></p>
            <p class="copy" v-html="$t('module3.slide11.copy2')"></p>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 10" class="delay-2">
            <h1 class="heading2" v-html="$t('module3.slide11.heading2')"></h1>
          </div>
        </transition>

        <div class="share">
          <transition name="fadeLeft" appear>
            <a
              :href="pdfFile"
              targer="_blank"
              class="button delay-3"
              v-show="slideIndex == 10"
              target="_blank"
            >
              <img
                v-show="slideIndex == 10"
                src="@/assets/module3/slide11/download_print.png"
              />
            </a>
          </transition>
        </div>
      </div>

      <div class="page page--narrow">
        <transition name="fadeUp" appear>
          <h2 class="heading3 delay-3" v-show="slideIndex == 10">
            {{ $t("module3.slide11.heading3") }}
          </h2>
        </transition>
        <transition name="fadeUp" appear>
          <p class="copy delay-4" v-show="slideIndex == 10">
            {{ $t("module3.slide11.copy3") }}
          </p>
        </transition>
        <transition name="fadeUp" appear>
          <p class="copy delay-5 copy--narrow" v-show="slideIndex == 10">
            {{ $t("module3.slide11.copy4") }}
          </p>
        </transition>
      </div>

      <div class="page">
        <transition name="fadeRight" appear>
          <p class="copy delay-6" v-show="slideIndex == 10">
            {{ $t("module3.slide11.copy5") }}
          </p>
        </transition>
        <transition name="fadeRight" appear>
          <p class="copy copy--bottom delay-7" v-show="slideIndex == 10">
            {{ $t("module3.slide11.copy6") }}
          </p>
        </transition>
      </div>
    </div>

    <transition name="fadeRight" appear>
      <img
        class="delay-8 polaroid"
        v-show="slideIndex == 10"
        src="@/assets/module3/slide11/images-02.png"
      />
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false,
      pdfFile:
        window?.CF_EBOOK_VARS?.documents?.book_3_document_2?.url ||
        "../Week-3-Script.pdf"
    };
  },
  props: ["slideIndex"],
  methods: {}
};
</script>
